/**公众组件model弹窗
 *  option =  {
    type: 'success'|'alert'|'confirm',
    title: String, // 标题
    content: String, // 内容
    showClose: Boolean,// 是否显示关闭按钮图标
    icon: Base64, // 图片 base64 字符串 覆盖现有图标 require('@/assets/img/common/success.png') /none-无
    onConfirm: function, // 点击确定按钮
    onCancel: function, // 点击取消按钮
    customClosed: function,//自定义的关闭方法
	customSure: function,//自定义的确认方法
	ConfirmText:String  // 自定义confirm的确认按钮文案
	cancelButtonText :String  // 自定义confirm的取消按钮文案
	successBtnText : String // 自定义success的确认按钮文案
	classname: String //类名
}
 */

// 引入组件
import Modal from './index.vue';
import Vue from 'vue';
// 返回一个 扩展实例构造器
const ModalConstructor = Vue.extend(Modal);
let toastDom = null;

function showModal(option) {
	toastDom = new ModalConstructor({
		el: document.createElement('div'),
		data() {
			return {
				...option,
				show: true,
			};
		},
		methods: {},
	});
}

// 注册为全局组件的函数
function $Modal(option) {
	let initOption = {
		title: '',
		content: '',
		showClose: false,
		type: 'success',
		icon: '',
		closeOnPopstate: true,
		ConfirmText: '确定',
		cancelButtonText: '取消',
		successBtnText: '确定',
		onConfirm: () => {},
		onCancel: () => {},
		customSure: () => {},
		customClosed: () => {},
		show: true,
	};
	Object.assign(initOption, option);
	if (toastDom) {
		Object.assign(toastDom, initOption);
	} else {
		showModal(initOption);
	}
}
// 导出
export default {
	install: function(Vue) {
		Vue.prototype.$modal = $Modal;
	},
};
